"use client"

import { createContext, type PropsWithChildren, use, useCallback, useMemo, useState } from "react"

type SearchContextType = {
  isOpen: boolean
  open: () => void
  close: () => void
}

const SearchContext = createContext<SearchContextType>(null!)

const SearchProvider = (props: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false)
  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const contextValue = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close])

  return <SearchContext.Provider value={contextValue} {...props} />
}

const useSearch = () => {
  const context = use(SearchContext)

  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider")
  }

  return context
}

export { SearchProvider, useSearch }
